import { useAuth0 } from '@auth0/auth0-react';
import { AppRoutes } from './pages/routes';
import { securityOptions } from './shared/service/apiConfig';
import RexSupportWidget from './components/RexSupportWidget';

function App() {
  const { getAccessTokenSilently } = useAuth0();

  securityOptions.setAccessTokenSilently(getAccessTokenSilently);

  return (
    <>
      <AppRoutes />
      <RexSupportWidget />
    </>
  );
}

export default App;
